import { Injectable } from '@angular/core';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
declare let gtag: Function;

@Injectable({
  providedIn: 'root',
})

export class GaService {
  constructor(protected $gaService: GoogleAnalyticsService) {}
  trackWithGA(data: string, type: string, userType?:string): void {
    if (type == 'tab') {
      this.$gaService.event(`result page visited on mode ${data}`, data, data);
    } else if (type == 'entityType') {
      this.$gaService.event(`${data} page visited`, data, data);
    }  else if (type == 'searchParams') {
  gtag('set', 'user_properties', { 'event_category': userType }); // sticky 👈
  this.$gaService.event('Search Params', userType, data);          // your existing event
}
    else if (type == 'authentication'){
      this.$gaService.event('Authentication way', data, data);
    }
  }
}
